export default "__VITE_ASSET__CuQXkvM1__"